module.exports = __webpack_public_path__ + "img/bg-proyectos-10.6d655f75.png";